/* src/@fuse/components/widget/widget.component.scss */
fuse-widget {
  display: block;
  position: relative;
  perspective: 3000px;
  padding: 12px;
}
fuse-widget > div {
  position: relative;
  transform-style: preserve-3d;
  transition: transform 1s;
}
fuse-widget > .fuse-widget-front {
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  position: relative;
  overflow: hidden;
  visibility: visible;
  width: 100%;
  opacity: 1;
  z-index: 10;
  border-radius: 8px;
  transition:
    transform 0.5s ease-out 0s,
    visibility 0s ease-in 0.2s,
    opacity 0s ease-in 0.2s;
  transform: rotateY(0deg);
  backface-visibility: hidden;
  border: 1px solid;
}
fuse-widget > .fuse-widget-back {
  display: block;
  position: absolute;
  top: 12px;
  right: 12px;
  bottom: 12px;
  left: 12px;
  overflow: hidden;
  visibility: hidden;
  opacity: 0;
  z-index: 10;
  border-radius: 8px;
  transition:
    transform 0.5s ease-out 0s,
    visibility 0s ease-in 0.2s,
    opacity 0s ease-in 0.2s;
  transform: rotateY(180deg);
  backface-visibility: hidden;
  border: 1px solid;
}
fuse-widget > .fuse-widget-back [fuseWidgetToggle] {
  position: absolute;
  top: 0;
  right: 0;
}
fuse-widget.flipped > .fuse-widget-front {
  visibility: hidden;
  opacity: 0;
  transform: rotateY(180deg);
}
fuse-widget.flipped > .fuse-widget-back {
  display: block;
  visibility: visible;
  opacity: 1;
  transform: rotateY(360deg);
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-wrapper {
  padding: 16px 0;
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-wrapper .mat-form-field-infix {
  border: none;
  padding: 0;
}
fuse-widget .mat-form-field.mat-form-field-type-mat-select .mat-form-field-underline {
  display: none;
}
/*# sourceMappingURL=data:application/json;base64,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 */
